import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 6c1.636 0 3.088.785 4 2a4.99 4.99 0 0 1 3.783-1.995L20 6h8a2 2 0 0 1 1.994 1.85L30 8v16a2 2 0 0 1-1.85 1.994L28 26h-8a3 3 0 0 0-2.995 2.824L17 29c0 .564-.358.89-.771.976l-.166.022h-.125l-.063-.006c-.42-.046-.81-.332-.868-.856l-.012-.312a3 3 0 0 0-2.819-2.819L12 26H4a2 2 0 0 1-1.995-1.85L2 24V8a2 2 0 0 1 1.85-1.995L4 6zm0 2H4v16h8c1 0 1.93.293 2.71.798l.21.143.08.06V11a3 3 0 0 0-2.65-2.98l-.174-.015zm8 0h8v16h-8l-.217.005A4.98 4.98 0 0 0 17 25V11l.005-.176A3 3 0 0 1 20 8"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCatalog = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCatalog);
export default Memo;
